module.exports = "build/assets/bottomWave.6933f7f4.png";